import { createSpaRouter } from "@serophin/browser";
import { useEffect } from "preact/hooks";
import { AppDownloadBanner } from "./components/AppDownloadBanner";
import { AuthModalProvider } from "./contexts/AuthModalContext";
import { AudioPlayerProvider } from "./contexts/audio/AudioPlayerProvider";
import { HeaderContextProvider } from "./contexts/HeaderContext";
import { ToastProvider } from "./contexts/ToastContext";
import { Frame } from "./Frame";
import { refreshSession } from "./platform/session";
import { useThemeSync } from "./platform/theme";
import { NOT_FOUND_PAGE, SITE_ROUTES } from "./routes";

/**
 * One app, routed by pathname from the site root. Pages that need a session decide for themselves, so the
 * router never redirects (`isAuthenticated` is always true); a gated page sends the visitor to `/auth`.
 */
const { App: Routes } = createSpaRouter({
  base: "",
  routes: Object.fromEntries(SITE_ROUTES.map((route) => [route.path, { page: route.page }])),
  Layout: Frame,
  NotFound: NOT_FOUND_PAGE,
  isAuthenticated: () => true,
});

/** What runs once the app is up: the session check a hydrating page postponed, and the theme sync. */
const SiteEffects = () => {
  useEffect(() => {
    refreshSession();
  }, []);
  useThemeSync();
  return null;
};

export const SiteApp = ({ url }: { url?: string }) => (
  <ToastProvider>
    <AuthModalProvider>
      <HeaderContextProvider>
        <AudioPlayerProvider>
          <SiteEffects />
          <Routes url={url} />
          <AppDownloadBanner />
        </AudioPlayerProvider>
      </HeaderContextProvider>
    </AuthModalProvider>
  </ToastProvider>
);
